<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <div
            class="d-flex justify-content-between align-items-center px-1 py-1"
          >
            <div>
              <h3 class="m-0 py-1">
                {{ $t("Series") }}
              </h3>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-right">
                <b-link :to="{ name: 'createSerie' }">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="mr-1 text-nowrap"
                  >
                    {{ $t("AñadirSerie") }}
                  </b-button>
                </b-link>
              </div>
              <span
                class="ml-1 cursor-pointer"
                @click="visibleFilter = !visibleFilter"
              >
                <feather-icon
                  icon="FilterIcon"
                  size="20"
                />
              </span>
            </div>
          </div>
          <div>
            <b-collapse
              id="collapse"
              v-model="visibleFilter"
              class="mt-2"
            >
              <div class="px-2">
                <b-row>
                  <b-col
                    v-if="role === 'admin_empresa' && !currentClient"
                    sm="4"
                  >
                    <b-form-group
                      :label="$t('Cliente')"
                      label-for="filter-client"
                    >
                      <v-select
                        v-model="client"
                        label="name"
                        :filterable="true"
                        :searchable="true"
                        :options="listClients"
                        :placeholder="$t('Cliente')"
                      >
                        <template
                          slot="option"
                          slot-scope="option"
                        >
                          {{ option.name }}
                        </template>
                        <template
                          slot="selected-option"
                          slot-scope="option"
                        >
                          {{ option.name }}
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group
                      :label="$t('Busqueda')"
                      label-for="filter-search"
                    >
                      <b-row>
                        <b-col sm="8">
                          <b-form-input
                            v-model="searchTerm"
                            :placeholder="$t('Busqueda')"
                            type="text"
                            class="d-inline-block"
                          />
                        </b-col>
                        <b-col
                          sm="4"
                          style="padding-left: 0px"
                        >
                          <b-button
                            variant="primary"
                            @click="handleSearch"
                          >
                            {{ $t("Buscar") }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </div>
          <b-table
            hover
            responsive
            :items="items"
            :fields="seleccionarcolumnas"
          >
            <template #cell(client)="data">
              <span v-if="data.item.client">
                {{ data.item.client.name }}
              </span>
            </template>
            <template #cell(description)="data">
              <span v-if="data.item.description && data.item.description != 'null'" >
                <span v-html="data.item.description"></span>
              </span>
              <span v-else >
                -
              </span>
            </template>
            <template #cell(actions)="data">
              <span>
                <b-link
                  v-if="data.item.total_tags === 0"
                  :to="{ name: 'editSerie', params: { id: data.item.id } }"
                  class="mr-1"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    size="16"
                  />
                </b-link>
                <span
                  v-if="data.item.total_tags === 0"
                  class="text-danger cursor-pointer"
                  @click="deleteSerie(data.item.id, data.item.name)"
                >
                  <feather-icon icon="TrashIcon" />
                </span>
              </span>
            </template>
          </b-table>
        </b-card>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap"> {{ $t("PorPagina") }}: </span>
            <b-form-select
              v-model="pageLength"
              :options="pages"
              class="ml-50 mr-1"
              @input="handlePageChange"
            />
            <span class="text-nowrap">
              {{ $t("Total") }}: {{ totalItems }}</span>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BPagination,
  BFormInput,
  BFormSelect,
  BLink,
  BButton,
  BCard,
  BTable,
  BCol,
  BRow,
  BFormGroup,
  BCollapse,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import store from '@/store/index'
import vSelect from 'vue-select';

export default {
  components: {
    BCard,
    BPagination,
    BFormInput,
    BFormSelect,
    BTable,
    BButton,
    BCol,
    BRow,
    BLink,
    BCollapse,
    vSelect,
    BFormGroup,
  },
  data() {
    return {
      log: [],
      currentPage: 1,
      pageLength: 10,
      dir: false,
      visibleFilter: false,
      pages: ['10', '15', '25'],
      client: '',
      columnsClient: [
        {
          label: this.$t('Nombre'),
          key: 'name',
        },
        {
          label: this.$t('Descripcion'),
          key: 'description',
        },
        {
          label: this.$t('TotalTags'),
          key: 'total_tags',
        },
        {
          label: this.$t('Acciones'),
          key: 'actions',
          class: 'text-right',
        },
      ],
      columns: [
        {
          label: this.$t('Nombre'),
          key: 'name',
        },
        {
          label: this.$t('Descripcion'),
          key: 'description',
        },
        {
          label: this.$t('TotalTags'),
          key: 'total_tags',
        },
        {
          label: this.$t('Cliente'),
          key: 'client',
        },
        {
          label: this.$t('Acciones'),
          key: 'actions',
          class: 'text-right',
        },
      ],
      searchTerm: '',
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'companies/getCurrentCompany',
      currentClient: 'clients/getCurrentClient',
      items: 'series/getItems',
      totalItems: 'series/getTotalItems',
      listClients: 'clients/getItems',
      currentUser: 'auth/getUser',
      role: 'auth/getRole',
    }),
    seleccionarcolumnas() {
      if (this.currentClient) {
        return this.columnsClient
      }
      return this.columns
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.getListClients({
      company: this.currentCompany.id,
      page: 1,
      per_page: 999999,
      search: '',
    })
    this.chargeData()
  },
  watch: {
    client() {
      this.chargeData()
    },
  },
  methods: {
    ...mapActions({
      list: 'series/getListSeries',
      delete: 'series/delete',
      getListClients: 'clients/getListClients',
    }),
    chargeData() {
      let cliente = this.currentClient ? this.currentClient.id : ''
      if (this.role !== 'admin_cliente' && cliente === '') {
        cliente = this.client ? this.client.id : ''
      }
      this.list({
        client: cliente,
        page: this.currentPage,
        per_page: this.pageLength,
        search: this.searchTerm,
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.chargeData()
    },
    handleChangePage(page) {
      this.currentPage = page
      this.chargeData()
    },
    handlePageChange() {
      this.currentPage = 1
      this.chargeData()
    },
    onSortChange(params) {
      this.currentPage = 1
      this.chargeData()
    },
    deleteSerie(id, name) {
      this.$bvModal
        .msgBoxConfirm(this.$t('EliminarConfirm', { nombre: name }), {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: this.$t('Eliminar'),
          cancelTitle: this.$t('Cancelar'),
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.delete(id)
          }
        })
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
